﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            profilePictureUrl: String
        };
    }

    static get targets() {
        return ["profilePicture"];
    }

    refreshProfilePicture() {
        this.profilePictureTargets.forEach(ppt => {
            ppt.src = `${this.profilePictureUrlValue}?width=${ppt.getAttribute("width")}&height=${ppt.getAttribute("height")}&${new Date().getTime()}`;
        });
    }
}
